import { useEffect } from 'react';
import { REPEATER_INFO, CONTACT_INFO } from '@/data/repeater';

interface SEOProps {
  title?: string;
  description?: string;
}

export function SEO({ 
  title = `${REPEATER_INFO.callsign} Multi-Mode Digital Repeater - ${REPEATER_INFO.location}`,
  description = `KQ4TNV DMR repeater in Stafford, Virginia. Multi-mode digital voice supporting DMR, YSF/C4FM, D-STAR, and M17 with XLX556 cross-mode transcoding.`
}: SEOProps) {
  useEffect(() => {
    // Set document title
    document.title = title;

    // Set or update meta tags
    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Basic meta tags
    setMetaTag('description', description);
    setMetaTag('keywords', 'amateur radio, ham radio, DMR, digital voice, repeater, KQ4TNV, Stafford VA, YSF, C4FM, D-STAR, M17, XLX556, BrandMeister');
    
    // Open Graph tags
    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:url', CONTACT_INFO.website, true);
    setMetaTag('og:site_name', REPEATER_INFO.callsign, true);
    
    // Twitter Card tags
    setMetaTag('twitter:card', 'summary');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);

    // Add Schema.org structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BroadcastService",
        "name": `${REPEATER_INFO.callsign} Multi-Mode Digital Repeater`,
        "description": REPEATER_INFO.description,
        "serviceArea": {
          "@type": "Place",
          "name": REPEATER_INFO.location
        },
        "provider": {
          "@type": "Organization",
          "name": REPEATER_INFO.callsign,
          "url": CONTACT_INFO.website,
          "email": CONTACT_INFO.email
        }
      });
      document.head.appendChild(script);
    }
  }, [title, description]);

  return null;
}
